<template>
    <form id="onboarding-de" class="wrapper" role="form" method="post">
        <template v-if="showDisclaimer">
            <header>
                <span class="headline-xlg">Unser Programm ist nur für Typ-2-Diabetiker*innen</span>
            </header>

            <div class="text-wrapper">
                <p>Wir freuen uns, dass Sie sich Gedanken über Ihre Gesundheit machen. Dennoch ist Vitadio nur für Patient*innen mit einer Typ-2-Diabetes-Diagnose verfügbar.</p>
                <p>Interessante Fakten zur Diabetesprävention finden Sie in unserer <a href="https://vitadio.de/ratgeber/" target="_blank">Ratgeber</a>.</p>

                <v-button href="/" label="Zurück zur Startseite" position="center"></v-button>
                <v-button label="Nochmal versuchen" variant="ghost" position="center" @onClick="goBack()"></v-button>
            </div>
        </template>
        <template v-else>
            <header>
                <span class="headline-xlg">Haben Sie die Diagnose Typ-2-Diabetes?</span>
            </header>

            <div class="form-input-radio-button-wrapper-two-columns">
                <div 
                    class="form-input-radio-button-big"
                    id="yes"
                    @click="chooseOption('Ja')"
                    >
                    <div class="form-input-radio-button-inner">
                        <figure class="form-input-radio-button-icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.9912 31.3305C24.4562 31.3305 31.3184 24.4682 31.3184 16.0031C31.3184 7.53807 24.4562 0.675781 15.9912 0.675781C7.52627 0.675781 0.664062 7.53807 0.664062 16.0031C0.664062 24.4682 7.52627 31.3305 15.9912 31.3305Z" fill="#54DBA3"/>
                            <path d="M16 32.0003C7.17759 32.0003 0 24.8227 0 16.0002C0 7.17767 7.17759 0 16 0C24.8224 0 32 7.17767 32 16.0002C32 24.8227 24.8224 32.0003 16 32.0003ZM16 1.34565C7.91975 1.34565 1.34435 7.91983 1.34435 16.0015C1.34435 24.0831 7.91847 30.6573 16 30.6573C24.0815 30.6573 30.6556 24.0831 30.6556 16.0015C30.6556 7.91983 24.0815 1.34565 16 1.34565Z" fill="#54DBA3"/>
                            <path d="M14.0928 23.7985C13.6653 23.7985 13.2544 23.629 12.9514 23.326L5.69159 16.0662C5.06114 15.4357 5.06114 14.4149 5.69159 13.7845C6.32203 13.154 7.34282 13.154 7.97326 13.7845L14.0928 19.9041L23.9771 10.0197C24.6076 9.38926 25.6283 9.38926 26.2588 10.0197C26.8892 10.6502 26.8892 11.671 26.2588 12.3014L15.2343 23.326C14.9313 23.629 14.5217 23.7985 14.0928 23.7985Z" fill="white"/>
                            </svg>
                        </figure> 
                        <span class="label-static">Ja</span>
                    </div>
                </div>
                
                <div 
                    class="form-input-radio-button-big form-input-radio-button--danger"
                    id="no"
                    @click="chooseOption('Nein')"
                    >
                    <div class="form-input-radio-button-inner">
                        <figure class="form-input-radio-button-icon">
                            <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.5 31C24.7843 31 31.5 24.2843 31.5 16C31.5 7.71573 24.7843 1 16.5 1C8.21573 1 1.5 7.71573 1.5 16C1.5 24.2843 8.21573 31 16.5 31Z" fill="#FF3E57"/>
                            <path d="M10.1199 25C9.70499 25 9.29141 24.8415 8.97446 24.5258C8.34185 23.8932 8.34185 22.8689 8.97446 22.2363L22.736 8.47447C23.3686 7.84184 24.3929 7.84184 25.0255 8.47447C25.6582 9.10709 25.6582 10.1314 25.0255 10.764L11.264 24.5258C10.9483 24.8415 10.5334 25 10.1186 25H10.1199Z" fill="white"/>
                            <path d="M16.5 32C7.67759 32 0.5 24.8224 0.5 16C0.5 7.17759 7.67759 0 16.5 0C25.3224 0 32.5 7.17759 32.5 16C32.5 24.8224 25.3224 32 16.5 32ZM16.5 1.34564C8.41975 1.34564 1.84435 7.91975 1.84435 16.0013C1.84435 24.0828 8.41847 30.6569 16.5 30.6569C24.5815 30.6569 31.1556 24.0828 31.1556 16.0013C31.1556 7.91975 24.5815 1.34564 16.5 1.34564Z" fill="#FF3E57"/>
                            <path d="M23.8814 25C23.4666 25 23.053 24.8415 22.736 24.5258L8.97446 10.764C8.34185 10.1314 8.34185 9.10709 8.97446 8.47447C9.60707 7.84184 10.6314 7.84184 11.264 8.47447L25.0255 22.2363C25.6582 22.8689 25.6582 23.8932 25.0255 24.5258C24.7099 24.8415 24.295 25 23.8801 25H23.8814Z" fill="white"/>
                            </svg>
                        </figure> 
                        <span class="label-static">Nein</span>
                    </div>
                </div>
            </div>
        </template>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                checkedYes: false,
                checkedNo: false, 
                showDisclaimer: false,
                options: [
                    {label: 'Ja', icon: 'input-icon-check', danger: false},
                    {label: 'Nein', icon: 'input-icon-times', danger: true}
                ]
            }
        },

        methods: {
            chooseOption(selection) {
                if (selection === 'Ja') {
                    $('#yes').addClass('active')
                    this.checkedYes = true
                    this.checkedNo = false
                    this.showDisclaimer = false

                    window.dataLayer.push({
                        'event': 'pre_registration_web',
                        'conversion': 'Type 2 confirmation'
                    })

                    this.onClickButton()
                }

                if (selection === 'Nein') {
                    $('#no').addClass('active')
                    this.checkedNo = true
                    this.checkedYes = false

                    setTimeout(() => {
                        this.showDisclaimer = true
                    }, 250);
                }
            },

            onClickButton () {
                setTimeout(() => {
                    this.$emit('clicked', null)
                }, 250);
            },

            goBack() {
                this.checkedNo = false
                this.checkedYes = false
                this.showDisclaimer = false
                $('.form-input-radio-button-big').removeClass('active')
            }
        }
    }
</script>